module.exports = __webpack_public_path__ + "static/img/庞老师 木版画黑白画.5eda6794.png";